export default __webpack_public_path__ + "static/media/Customer_filled.b91e3d3d.svg";